import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["waterSource", "day", "slotsContainer", "placeholder", "loading", "slotInput", "dayTotal"]
  static values = { eventId: Number, loadUrl: String, saveUrl: String }

  connect() {
    this.updateTotal()
    // Auto-load if day is pre-selected (today) and source is already chosen
    if (this.dayTarget.value && this.waterSourceTarget.value) {
      this.loadData()
    }
  }

  loadData() {
    const waterSourceId = this.waterSourceTarget.value
    const day = this.dayTarget.value

    if (!waterSourceId || !day) {
      this.showPlaceholder()
      return
    }

    this.showLoading()

    fetch(this.loadUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
      },
      body: JSON.stringify({ water_source_id: waterSourceId, day: day })
    })
    .then(response => response.json())
    .then(data => {
      this.populateSlots(data.slots)
      this.showSlotsContainer()
      this.updateTotal()
    })
    .catch(error => {
      console.error("Error loading data:", error)
      this.showPlaceholder()
    })
  }

  populateSlots(slots) {
    this.slotInputTargets.forEach(input => {
      const start = input.dataset.slotStart
      const slotData = slots.find(s => s.start === start)
      input.value = slotData ? slotData.liters : 0
    })
  }

  saveData() {
    const waterSourceId = this.waterSourceTarget.value
    const day = this.dayTarget.value

    if (!waterSourceId || !day) return

    const slots = this.slotInputTargets.map(input => ({
      start: input.dataset.slotStart,
      liters: parseFloat(input.value) || 0
    }))

    fetch(this.saveUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
      },
      body: JSON.stringify({ water_source_id: waterSourceId, day: day, slots: slots })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        this.showNotification(data.message, "success")
      } else {
        this.showNotification(data.error, "error")
      }
    })
    .catch(error => {
      console.error("Error saving data:", error)
      this.showNotification("Error al guardar", "error")
    })
  }

  updateTotal() {
    const total = this.slotInputTargets.reduce((sum, input) => {
      return sum + (parseFloat(input.value) || 0)
    }, 0)

    if (this.hasDayTotalTarget) {
      this.dayTotalTarget.textContent = total.toFixed(1)
    }
  }

  showPlaceholder() {
    this.placeholderTarget.classList.remove("hidden")
    this.slotsContainerTarget.classList.add("hidden")
    this.loadingTarget.classList.add("hidden")
  }

  showLoading() {
    this.placeholderTarget.classList.add("hidden")
    this.slotsContainerTarget.classList.add("hidden")
    this.loadingTarget.classList.remove("hidden")
  }

  showSlotsContainer() {
    this.placeholderTarget.classList.add("hidden")
    this.loadingTarget.classList.add("hidden")
    this.slotsContainerTarget.classList.remove("hidden")
  }

  showNotification(message, type) {
    alert(message)
  }
}
